import useMutationOrganizerCreateUpdate from "./organizer-use-mutation-create-update";
import useMutationOrganizerDelete from "./organizer-use-mutation-delete";

export const organizerUseMutation = {
  createUpdate: useMutationOrganizerCreateUpdate,
  delete: useMutationOrganizerDelete,
};
